/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrantType } from './grantType';


export interface OIDCClient { 
    id?: number;
    applicationId?: number;
    name?: string | null;
    friendlyName?: string | null;
    description?: string | null;
    isEnabled?: boolean;
    alwaysIncludeUserClaimsInIdToken?: boolean;
    requirePkce?: boolean;
    allowPlainTextPkce?: boolean;
    allowOfflineAccess?: boolean;
    identityTokenLifetime?: number;
    accessTokenLifetime?: number;
    authorizationCodeLifetime?: number;
    refreshTokenUsage?: number;
    allowedRedirectUris?: Array<string> | null;
    allowedLogoutRedirectUris?: Array<string> | null;
    secret?: string | null;
    useExistingSecret?: boolean;
    grantType?: GrantType;
}

